<template >
    <div class="container-fluid" v-if="lesson">


       <div class="row">
      <div class="col-lg-4">
        <div class="card shadow mb-4">
          <div class="card-header">
            <h4>{{lesson.name}}</h4>
          </div>
          <div class="card-body">
            <p>{{lesson.description}}</p>
            <div class="btn btn-info btn-sm">
              <router-link :to="{ name: 'LessonEdit', params: { lessonId: lesson.id}}" class="text-white">Хичээлийн мэдээлэл засах</router-link>
            </div>
            <div class="btn btn-default  btn-sm mx-1 my-2">
              <router-link :to="{ name: 'ImageAdd', params: { objectPath: 'lessons/'+lesson.id}}">Хичээлийн зураг оруулах</router-link>
            </div>
            <br/>

            <br/>
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <button class="btn btn-outline-secondary btn-sm" type="button" v-for="type in lesson.types">
                  {{type}}

                </button>

              </div>
            </div>
            
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="card shadow mb-4">
          <div class="card-header">
            <h4>Мэдээлэл</h4>
          </div>
          <div class="card-body">
            <p style="margin-bottom: 0rem;">Багш:<span style="font-weight:bold">{{lesson.profession}}</span></p>
            <p style="margin-bottom: 0rem;">Xичээлийн код: <span style="font-weight:bold">{{lesson.lectureCode}}, {{lesson.id}}</span></p>
            <p style="margin-bottom: 0rem;" v-if="lesson.semester">Улирал: <span style="font-weight:bold">{{lesson.semester.id}}</span></p>
            <p style="margin-bottom: 0rem;" v-if="lesson.credit">Кредит: <span style="font-weight:bold">{{lesson.credit}}</span></p>
            <p style="margin-bottom: 0rem;" v-if="lesson.school">Сургууль: <span style="font-weight:bold">{{lesson.school.id}}</span></p>
            <p style="margin-bottom: 0rem;" v-if="lesson.department">Xөтөлбөрийн баг: <span style="font-weight:bold">{{lesson.department.id}}</span></p>
            <p style="margin-bottom: 0rem;" v-if="lesson.program">Хөтөлбөр: <span style="font-weight:bold">{{lesson.program.id}}</span></p>
          </div>
        </div>
      </div>


    </div>

    <hr class="mb-5"/>


      <div class="card shadow mb-4" v-if="topic">
        <div class="card-header py-3">
          <div class="row">

              <div class="col"><h4 class="m-0 font-weight-bold text-primary">{{topic.name}}</h4></div>
              <div class="col-auto">


              </div>


          </div>
        </div>
        <div class="card-body" >


            <div v-if="topic">
              <div v-if="topic.tags!=null && topic.tags!=undefined && topic.tags.length>0">
                Түлхүүр үгс:
                <span class="badge badge-pill badge-success mr-2" v-for="(tag, ti) in topic.tags">
                  {{tag}}
                  <i class="fas fa-search ml-2" style="cursor:pointer" @click="searchQuestions(tag)"></i>
                </span>
              </div>
              <div class="row my-3">
                <div class="col">
                   <input v-model.trim="tagText" type="text" class="form-control" placeholder="Та хайх түлхүүр үгээ оруулна уу" v-on:keyup.enter="searchQuestions(tagText)">
                </div>
                <div class="col-auto">
                  <button class="btn btn-info" @click="searchQuestions(tagText)">Түлхүүр үгээр хайх</button>
                </div>
              </div>

              <div class="my-4">
                <div class="row">
                  <div class="col-md-6 col-sm-12">
                    <h5>Хайлтын үр дүн</h5>
                    <div class="table-responsive" v-if="results!=null && results!=undefined && results.length>0">
                      <div class="row my-3">
                        <div class="col-auto">
                          <div class="row">
                            <div class="col-auto">Эхний</div> 
                        
                            <div class="col-auto">
                              <input v-model.number="count" type="number" class="form-control" placeholder="Та нэмэх асуултын тоогоо оруулна уу">
                            </div>
                          </div>
                        </div>
                        <div class="col-auto">
                          <button class="btn btn-danger btn-sm" @click="addCounted(count)">асуулт нэмэх</button>
                        </div>
                      </div>
                      <table class="table table-sm table-bordered">
                        <thead>
                          <tr>
                            <th>№</th>
                            <th>Асуулт</th>
                            <th>Үйлдэл</th>
                          </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(q, index) in results">
                              <th>{{index+1}}.</th>
                              <th>
                                {{q.title}}
                              </th>
                              <th>
                                <button class="btn btn-sm btn-success" @click="addQuestion(q)">нэмэх</button>
                              </th>
                            </tr>
                        </tbody>
                      </table>
                    </div>
                    <div v-else class="alert alert-inof">Одоогоор хайлтын үр дүн байхгүй байна.</div>
                  </div>
                  <div class="col-md-6 col-sm-12">
                    <h5>Хадгалах асуултууд</h5>
                    <div class="table-responsive" v-if="tmpQuestions!=null && tmpQuestions!=undefined && tmpQuestions.length>0">
                      <div class="row my-3">      
                        <div class="col-md-auto form-group" >
                          <div class="">
                            <input type="checkbox"  v-bind:id="'answerTypeCheck'" v-model="isExam">
                            <label for="answerTypeCheck">Шалгалт</label>
                          </div>
                        </div>
                        <div class="col-md-auto">
                          <button class="btn btn-danger btn-sm" @click="createExam">Доорх асуултуудаар сорил үүсгэх</button>
                        </div>
                      </div>
                      <table class="table table-sm table-bordered">
                        <thead>
                          <tr>
                            <th>№</th>
                            <th>Асуулт</th>
                            <th>Үйлдэл</th>
                          </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(q, index) in tmpQuestions">
                              <th>{{index+1}}.</th>
                              <th>
                                {{q.title}}
                              </th>
                              <th>
                                <button class="btn btn-sm btn-success" @click="remove(q, index)">хасах</button>
                              </th>
                            </tr>
                        </tbody>
                      </table>
                    </div>
                    <div v-else class="alert alert-inof">Одоогоор хадгалах асуулт байхгүй байна.</div>
                  </div>
                </div>
              </div>
            </div>

        </div>
      </div>
      <hr class="mb-5"/>
      <div v-if="loading==true" style="position:fixed;z-index:10000000; top:45%;left:45%">
        <div class="spinner-grow text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <div class="spinner-grow text-secondary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <div class="spinner-grow text-success" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <div class="spinner-grow text-danger" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <div class="spinner-grow text-warning" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <div class="spinner-grow text-info" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <div class="spinner-grow text-dark" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>

    </div>
    
</template>

<script>
const fb = require('../../firebaseConfig.js')
import { mapState } from 'vuex'
import moment from 'moment'
import firebase from 'firebase'

export default {
    name: "TopicCreateExam",

    data() {
        return {
            lesson: null,
            topic:null,
            tagText:null,
            tmpQuestions:[],
            results:[],
            count:10,
            loading:false,
            isExam:false
            
        };
    },
    methods: {
        
      _getQA(){

        fb.db.collection("lessons").doc(this.lessonId).get().then(doc=> {
            let lesson=doc.data();
            lesson.id=doc.id;
            this.lesson=lesson;
            doc.ref.collection("topics").doc(this.topicId).get().then(tdoc=>{
              if(tdoc.exists){
                let topic=tdoc.data();
                topic.id=tdoc.id;
                this.topic=topic;
              }
            });
          
        });



      },


      goStat(type, topic){
        this.$router.push({ name: 'TopicStat', params: { lessonId: this.lessonId, type: type.id, topicId: topic.id} })
      },


      setPropContent(value,topic, item, propertyName){
        if(this.lesson!=null && topic!=null && item!=null && propertyName!=null)
          this.setProperty(propertyName, fb.db.doc("lessons/"+this.lesson.id+"/topics/"+topic.id+"/details/"+item.id), value);
      },
      setProperty(propertyName, object, value){
        if(object!=null && propertyName!=null){
          var tmp={};
          tmp[propertyName]=value;
          object.update(tmp);
        }
      },
      async searchQuestions(tag){
        if(tag!=null && tag!=undefined && tag!=''){
          this.loading=true;
          var searchFunction = firebase.functions().httpsCallable('searchQuestionByTag');
          searchFunction({lessonId: this.lessonId, tag: tag}).then((result) =>{
            if(result.data==null || result.data==undefined || result.data.length==0)
              alert("Мэдээлэл олдсонгүй.Та өөр түлхүүр үг ашиглан хайна уу");
            this.results=result.data;
            this.loading=false;
            this.tagText=null;
          });

        }
      },
      addQuestion(q){
        if(this.tmpQuestions==null || this.tmpQuestions==undefined)
          this.tmpQuestions=[];
        this.tmpQuestions.push(Object.assign({}, q));
      },
      remove(q, index){
        this.tmpQuestions.splice(index, 1);
      },
      addCounted(count){

        if(count!=null && count!=undefined && count>0){
          if(this.results!=null && this.results!=undefined){

            for(var i=0;i<count;i++){

              if(this.results.length>i)
                this.tmpQuestions.push(Object.assign({}, this.results[i]));
            }
          }
        }
      },
      createExam(){
        if(this.tmpQuestions!=null && this.tmpQuestions!=undefined && this.tmpQuestions.length>0){
          this.loading=true;
          var searchFunction = firebase.functions().httpsCallable('createExam');
          searchFunction({
            lessonId: this.lessonId, 
            topicPath:fb.db.collection("lessons").doc(this.lessonId).collection("topics").doc(this.topicId).path,
            questions: this.tmpQuestions,
            isExam: this.isExam
            }).then((result) =>{
            if(result.data!=null && result.data!=undefined){
              this.$router.push({ name: 'DetailQuestions', params: { lessonId:this.lessonId, topicId: this.topicId, detailId: result.data} });
            }
            else
              alert("Ямар нэг зүйл буруу боллоо. Та дахин оролдоно уу.");
          });
        }
      }


    },
    computed: {
        ...mapState(['userProfile', 'currentUser'])
    },
    props: {
        lessonId: { 
            required: true,
        },
        topicId:{
          required:true
        }
    },
    created() {
        var _this=this;
        if(this.lessonId!=null && this.lessonId!='')
          this._getQA();
            
    },
    filters: {
		  formatDate(val) {
          if (!val) { return '-' }
          let date = val.toDate()
          return moment(date).format('MM/DD/YYYY HH:mm');
      },
    }
  
};
</script>

